export interface PaymentData {
    valor: string | number
    nomeTitular: string
    numeroDocumentoTitular: string
    agencia: string
    compe: string
    ispb: string
    numeroConta: string
    tipoConta: string
    email: string
    telefone: string
    dataLiquidacao: string
    observacao: string
    tipoPagamento: number
    quantParcelas: string | number
    frequenciaPagamento: string | number
}

export interface InputsFormStep1 {
    valor: string | number
    nomeTitular: string
    numeroDocumentoTitular: string
    agencia: string
    compe: string
    ispb: string
    numeroConta: string
    tipoConta: string
    email: string
    telefone: string
    observacao: string
}

export interface InputsFormStep2 {
    dataLiquidacao: string
    tipoPagamento: number
    quantParcelas: string | number
    frequenciaPagamento: string | number
}

export interface Inputs {
    cnpjPagador: string
    // tipoLink: string | number
    // tipoCobranca: string | number
    quantParcelas: string | number
    dataLiquidacao: string
    // contatoData: any
    observacao: string
    nomeTitular: string
    email: string
    telefone: string
}

export interface InitialContactProtocol {
    nomeTitular: string
    numeroDocumentoTitular: string
    agencia: string
    compe: string
    ispb: string
    tipoConta: string
    numeroConta: string
    email: string
    telefone: string
    id: undefined | string | number
}

export const initialContact: InitialContactProtocol = {
    nomeTitular: '',
    numeroDocumentoTitular: '',
    agencia: '',
    compe: '',
    ispb: '',
    tipoConta: 'null',
    numeroConta: '',
    telefone: '',
    email: '',
    id: undefined,
}

// export interface NomePagadorInput {
//     agencia: string
//     compe: string
//     email: string
//     id: string
//     ispb: string
//     nomeTitular: string
//     numeroConta: string
//     numeroDocumentoTitular: string
//     telefone: string
//     tipoConta: string
// }

// export const NomePagadorInputInitial: NomePagadorInput = {
//     agencia: '',
//     compe: '',
//     email: '',
//     id: '',
//     ispb: '',
//     nomeTitular: '',
//     numeroConta: '',
//     numeroDocumentoTitular: '',
//     telefone: '',
//     tipoConta: '',
// }
